import React, { Fragment } from "react";
import { Container } from "../../components";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { Text } from "../text";
import { useLuminaryAnalytics } from "./luminary_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./luminary_partner_config";

const Theme = lazyWithRetry(() => import("./luminary_theme"));

const faqs = [
  {
    question: "What are Luminary's hours?",
    answer: (
      <Container>
        <Text>Luminary’s current hours are: </Text>
        <Text>Monday through Thursday from 8:30am-7pm</Text>
        <Text>Fridays from 8:30am-6pm</Text>
        <Text>Saturdays from 10am-4pm</Text>
      </Container>
    ),
  },
  {
    question: "Do I need to reserve a desk/seat before arriving? ",
    answer:
      "No! Your day pass is all you'll need. Luminary offers three floors of communal co-working spaces, with a variety of seating options! Your day pass grants you access to all of this, and you do not need to reserve any co-working seats or 'desks' in advance!",
  },
  {
    question: "Are there age requirements?",
    answer:
      "No! We welcome all ages and currently have Members from 19-81! However, in order to access our wine on tap Members and Guests will need to be at least 21.",
  },
  {
    question:
      "Are men or people who don't identify as women allowed to join Luminary?",
    answer: "Luminary welcomes ALL of our allies!",
  },
  {
    question: "Are there private areas I can take calls?",
    answer:
      "Yes, you can take your calls in a phone booth! We have 10 phone booths that are first come, first serve and can be used 1 hour at a time.",
  },
  {
    question: "Can I book a conference room?",
    answer:
      "Yes! Our conference rooms can hold 1-6 people and are $40/hour for non-members. If you are sharing the room, please note that all guests must pay for a Day Pass.",
  },

  {
    question: "Can I print/scan at Luminary?",
    answer:
      "Yes! We have printers/scanners, and our Community Managers on-site will be more than happy to assist you. We try to be environmentally responsible with our printing.",
  },

  {
    question: "Is the fitness studio open?",
    answer:
      "Yes! The fitness studio is now available to members to use for personal workouts. If you are interested in providing or receiving personal training sessions, hosting a group fitness class or reserving the fitness studio privately please contact info@weareluminary.com.",
  },

  {
    question: "Can I take photos or videos of the space?",
    answer:
      "Yes, you can take photos or record videos in the space on your phone. Any use of a professional camera will considered a photoshoot or videoshoot and is prohibited in our space unless a booking is made and approved by our team. You may reach out to bookings@weareluminary.com for any inquiries.",
  },

  {
    question: "Does Luminary have food available? ",
    answer:
      "While we do not sell food within the space, we do allow delivery directly to the space--the front desk will be happy to help you with this! In addition to delivery, there are also TONS of restuarants, snack places, and eateries within a few blocks. We also have refrigerators available to store anything you might bring from home! The Glass Ceiling Restaurant on our rooftop is also an option! The hours for this are Tues - Fri: 4pm - 9pm Sat - Sun: 12pm - 9pm",
  },
];

export function OfferingLuminaryDayPass() {
  useLuminaryAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: `Spend the day at Luminary in the heart of NoMad and work out of our inspiring NYC space designed with your day in mind. Access 15,000 sq of open workspace, phone booths, a Meditation Room, showers, and Beauty Bar - plus our rooftop lounge, The Glass Ceiling!`,
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
